import { render, staticRenderFns } from "./GroupBookingDetails.vue?vue&type=template&id=0f14aa00&scoped=true&"
import script from "./GroupBookingDetails.vue?vue&type=script&lang=js&"
export * from "./GroupBookingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f14aa00",
  null
  
)

export default component.exports